import React, { useState } from "react";
import { Box, Button, SpaceBetween } from "@amzn/awsui-components-react";
import useFolders from "../hooks/useFolders";
import { SavedFolder } from "../types/folder";
import { FolderTable } from "./folders/FolderTable";
import { FolderModal } from "./folders/FolderModal";

export function SavedSearches() {
  const {
    folders,
    saveFolder,
    updateFolder,
    deleteFolder,
    deleteTransaction,
    updateTransactionLabels,
  } = useFolders();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isFolderModalVisible, setIsFolderModalVisible] = useState(false);
  const [isShareModalVisible, setIsShareModalVisible] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [editingFolderId, setEditingFolderId] = useState<string | null>(null);
  const [sharingFolder, setSharingFolder] = useState<SavedFolder | null>(null);
  const [selectedFolderId, setSelectedFolderId] = useState("");
  const [error, setError] = useState<string>("");

  const clearEditState = (folder?: SavedFolder) => {
    setIsModalVisible(true);
    setFolderName(folder?.name || "");
    setEditingFolderId(folder?.id || null);
    setError("");
  };

  const closeModal = () => {
    clearEditState();
    setIsModalVisible(false);
  };

  const handleSaveFolder = () => {
    if (!folderName.trim()) {
      setError("Please enter a folder name");
      return;
    }
    try {
      editingFolderId
        ? updateFolder(editingFolderId, folderName)
        : saveFolder(folderName);
    } catch (e) {
      // Keep the window open with the reason, e.g. a duplicate name.
      setError(
        e instanceof Error ? e.message : "The folder could not be saved."
      );
      return;
    }
    closeModal();
  };

  const handleUpdateTransactionLabels = (
    folderId: string,
    transactionId: string,
    labels: string[]
  ) => {
    updateTransactionLabels(folderId, transactionId, labels);
  };

  const handleShare = (folder: SavedFolder) => {
    setSharingFolder(folder);
    setIsShareModalVisible(true);
  };

  const handleFolderSelect = () => {
    setIsModalVisible(false);
  };

  return (
    <Box margin={{ bottom: "l" }}>
      <SpaceBetween size="l">
        <Button onClick={() => clearEditState()} iconName="add-plus">
          Create New Folder
        </Button>
        <FolderTable
          folders={folders}
          onEdit={clearEditState}
          onDelete={deleteFolder}
          onShare={handleShare}
          onDeleteTransaction={deleteTransaction}
          onUpdateTransactionLabels={handleUpdateTransactionLabels}
        />
      </SpaceBetween>
      <FolderModal
        isModalVisible={isModalVisible}
        isFolderModalVisible={isFolderModalVisible}
        isShareModalVisible={isShareModalVisible}
        selectedFolderId={selectedFolderId}
        folderName={folderName}
        error={error}
        folders={folders}
        sharingFolder={sharingFolder}
        onModalDismiss={() => setIsModalVisible(false)}
        onCreateFolder={() => setIsFolderModalVisible(true)}
        onFolderSelect={handleFolderSelect}
        onFolderModalDismiss={() => setIsFolderModalVisible(false)}
        onShareModalDismiss={() => {
          setIsShareModalVisible(false);
          setSharingFolder(null);
        }}
        onSaveFolder={handleSaveFolder}
        setSelectedFolderId={setSelectedFolderId}
        setFolderName={setFolderName}
      />
    </Box>
  );
}
